import dayjs from 'dayjs';
import { formatUtils } from './formatUtils';

const { DATE_FORMATS } = formatUtils;
/**
 * 差分を取得する
 * @param date1 日付1
 * @param date2 日付2
 * @param formatKey 書式
 * @param unit 差分単位
 * @returns チェック結果
 */
const diff = (
  date1: string | Date | undefined,
  date2: string | Date | undefined,
  formatKey: keyof typeof DATE_FORMATS = 'YYYY_MM_DD',
  unit: dayjs.QUnitType | dayjs.OpUnitType = 'd'
) => {
  const format = DATE_FORMATS[formatKey];
  return dayjs(date1, format).diff(dayjs(date2, format), unit);
};

/**
 * 当日日付からの差分を取得する
 * @param date 日付
 * @param formatKey 書式
 * @param unit 差分単位
 * @returns チェック結果
 */
const diffNow = (
  date: string | Date | undefined,
  formatKey: keyof typeof DATE_FORMATS = 'YYYY_MM_DD',
  unit: dayjs.QUnitType | dayjs.OpUnitType = 'd'
) => {
  const now = new Date();
  now.setHours(0);
  now.setMinutes(0);
  now.setSeconds(0);
  now.setMilliseconds(0);
  return diff(date, now, formatKey, unit);
};

export const dateUtils = {
  diff,
  diffNow
};
